export const PHONE_NUMBER_ENDPOINTS = {
    GET_ALL: '/phone-numbers',
    CREATE: '/phone-numbers/create',
    GET_BY_ID: (id: string) => `/phone-numbers/${id}`,
    UPDATE: (id: string) => `/phone-numbers/${id}`,
    DELETE: (id: string) => `/phone-numbers/${id}`,
} as const;
